import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Copilot } from '@/features/copilot';
import { useNotificationFeed } from '@/features/notifications/useNotificationFeed';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  // Global live notification feed backing the header bell (escalations, leads).
  useNotificationFeed();

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto bg-slate-50 dark:bg-[#0B1120] transition-colors relative">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(34,197,94,0.04),rgba(255,255,255,0))] dark:bg-[radial-gradient(ellipse_80%_60%_at_50%_-10%,rgba(34,197,94,0.06),rgba(0,0,0,0))]" />
          <div className="relative z-10">
            {children}
          </div>
        </main>
      </div>
      <Copilot />
    </div>
  );
};